const Vr1 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-1/PNG%20n.1/360%20-n1/PUBLISH/`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 1 Level 1 Tour"
        ></iframe>
      </div>
    );
};

export default Vr1;
